<template>
    <v-container class="pa-4 text-center">
        <p class="display-1 font-weight-medium mb-0">Selamat Datang di {{company.name}}</p>
        <p class="display-1 font-weight-medium">Point Of Sales</p>
        <template>
            <p class="pl-8 body-2 text-left font-weight-bold mt-5">Pilih kategori: </p>
            <v-layout row wrap>
                <template v-for="(item, i) in item_categories">
                    <v-flex xs3 class="my-4" :key="i">
                        <template>
                            <v-card
                                class="mx-auto"
                                color="green lighten-5"
                                max-width="200"
                                height="100%"
                                style="cursor: pointer"
                                @click="onSelectProductCategory(item)"
                            >
                                <v-img
                                    :aspect-ratio="16/9"
                                    src="https://cdn.vuetifyjs.com/images/cards/kitchen.png"
                                    class="white--text align-end"
                                    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                                    height="50px"
                                    >
                                    <v-card-text class="text-left" v-text="item.name+' ('+item.total_products+')'"></v-card-text>
                                </v-img>
                                <!-- <v-card-text
                                    class="pt-6 text-left"
                                    style="position: relative; height:auto"
                                > -->
                                    <!-- <v-img
                                        :aspect-ratio="16/9"
                                        src="https://cdn.vuetifyjs.com/images/cards/kitchen.png"
                                        rounded
                                    >
                                    </v-img> -->
                                    <!-- <v-list-item-avatar
                                        tile
                                        size="80"
                                        color="grey"
                                    ></v-list-item-avatar>
                                    <span class="font-weight-light subtitle-2 black--text">{{item.name}}</span><br />
                                    <span class="font-weight-medium caption black--text">Jumlah Barang: {{item.total_products}}</span><br />
                                </v-card-text> -->
                            </v-card>
                        </template>
                    </v-flex>
                </template>
            </v-layout>
        </template>
        <template v-if="isShowProduct && listProduct.length > 0">
            <!-- <p class="display-1 font-weight-light mt-5">Daftar Barang</p> -->
            <p class="pl-8 body-2 text-left font-weight-light mt-5">Menampilkan {{selectedCategory.total_products}} barang dari kategori {{selectedCategory.name}}</p>
            <v-layout row wrap>
                <template v-for="(item, i) in listProduct">
                    <v-flex xs3 class="my-4" :key="i">
                        <template>
                            <v-hover v-slot:default="{ hover }">
                                <v-card
                                    class="mx-auto"
                                    color="green lighten-5"
                                    max-width="200"
                                    height="100%"
                                >
                                    <v-img
                                        :aspect-ratio="16/9"
                                        v-bind:src="item.attachment"
                                    >
                                    <v-expand-transition v-if="item.type == 'MANAGED_TIME'">
                                        <div
                                            v-if="hover"
                                            class="green darken-2 d-flex transition-fast-in-fast-out v-card--reveal white--text"
                                            style="height: 100%;"
                                        >
                                            <span>Available</span>
                                        </div>
                                    </v-expand-transition>
                                    <v-expand-transition v-else-if="item.type == 'UNMANAGE'">
                                        <div
                                            v-if="hover"
                                            class="green darken-2 d-flex transition-fast-in-fast-out v-card--reveal white--text"
                                            style="height: 100%;"
                                        >
                                            <span>Available</span>
                                        </div>
                                    </v-expand-transition>
                                    <v-expand-transition v-else>
                                        <div
                                            v-if="hover"
                                            :class="(Number(item.stock) <= 0) ? 'red darken-2 d-flex transition-fast-in-fast-out v-card--reveal white--text' : 'green darken-2 d-flex transition-fast-in-fast-out v-card--reveal white--text'"
                                            style="height: 100%;"
                                        >
                                            <span v-if="(Number(item.stock) <= 0)">Out of Stock</span>
                                            <span v-else>Available</span>
                                        </div>
                                    </v-expand-transition>
                                    </v-img>
                                    <v-card-text
                                        class="pt-6 text-left"
                                        style="position: relative; height:auto"
                                    >

                                        <v-btn
                                            absolute
                                            color="green darken-1"
                                            class="white--text"
                                            x-small
                                            fab
                                            right
                                            top
                                            v-if="item.type == 'MANAGED_TIME'"
                                            @click="openDialogJadwal()"
                                        >
                                            <v-icon>add</v-icon>
                                        </v-btn>
                                        <v-btn
                                            absolute
                                            color="green darken-1"
                                            class="white--text"
                                            x-small
                                            fab
                                            right
                                            top
                                            v-else-if="item.type == 'UNMANAGE'"
                                            @click="addToCart(item)"
                                        >
                                            <v-icon>add</v-icon>
                                        </v-btn>
                                        <v-btn
                                            absolute
                                            color="green darken-1"
                                            :disabled="Number(item.stock) <= 0"
                                            class="white--text"
                                            x-small
                                            fab
                                            right
                                            top
                                            v-else-if="item.type == 'MANAGED_STOCK'"
                                            @click="addToCart(item)"
                                        >
                                            <v-icon>add</v-icon>
                                        </v-btn>
                                        <span class="font-weight-light subtitle-2 black--text">{{item.name}}</span><br />
                                        <span class="font-weight-medium caption black--text">Harga: Rp. {{item.harga_jual}}</span><br />
                                        <span v-show="item.type == 'MANAGED_STOCK'" class="font-weight-medium caption black--text">Stok: {{item.stock}}</span>
                                    </v-card-text>
                                </v-card>
                            </v-hover>
                        </template>
                    </v-flex>
                </template>
            </v-layout>
        </template>
        <v-dialog v-model="dialog" max-width="500">
          <v-card>
            <v-container>
              <v-form @submit.prevent="addEvent" v-if="!alreadyJadwal">
                <v-row align="center">
                  <v-col class="d-flex" cols="12" sm="6">
                    <v-menu
                      v-model="menu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="inputStart"
                          label="Tanggal Mulai"
                          prepend-icon="event"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="inputStart" @change="[onCekJadwal(), inputEnd = inputStart]" @input="menu = false"></v-date-picker>
                    </v-menu>
                  </v-col>

                  <v-col class="d-flex" cols="12" sm="6">
                    <v-select :items="jamItemsStart" v-model="startJam" @change="onCekJadwal" label="Jam"></v-select>
                  </v-col>

                  <v-col class="d-flex" cols="12" sm="6">
                    <v-menu
                      v-model="menuFinish"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="inputEnd"
                          label="Tanggal Selesai"
                          prepend-icon="event"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="inputEnd" @change="onCekJadwal" @input="menuFinish = false"></v-date-picker>
                    </v-menu>
                  </v-col>

                  <v-col class="d-flex" cols="12" sm="6">
                    <v-select :items="jamItemsFinish" v-model="finishJam" @change="onCekJadwal" label="Jam"></v-select>
                  </v-col>
                  <v-col class="d-flex" cols="12" sm="12" v-if="jasaItems.length > 0">
                    <v-select prepend-icon="add_shopping_cart" :items="jasaItems" v-model="selectedJasa" label="Pilih Layanan"></v-select>
                  </v-col>
                  <v-col class="d-flex" cols="12" sm="12" v-else>
                    <p class="font-italic red--text caption">*Tidak ditemukan, silahkan cari jadwal lain.</p>
                  </v-col>
                </v-row>
                <v-btn type="submit" color="primary" v-if="jasaItems.length > 0 && selectedJasa" class="mr-4">
                  Book
                </v-btn>
              </v-form>
              <div v-else>
                    <p>Mohon selesaikan pesanan terlebih dahulu, sebelum memesan produk layanan lagi.</p>
                    <div class="text-right">
                        <v-btn color="primary" @click="dialog = false" class="mr-4">
                            Ok
                        </v-btn>
                    </div>
              </div>
            </v-container>
          </v-card>
        </v-dialog>
        <!-- <p class="title-1 font-weight-light text-center" style="margin-top: 80px">Silahkan pilih jenis produk yang ingin anda pesan:</p>
        <v-layout row wrap>
            <v-flex xs6 class="text-right">
                <template>
                    <v-btn class="ma-2 white--text" @click="$router.push('/daftar-barang')" color="teal darken-3">
                        <v-icon left>shopping_basket</v-icon> BARANG
                    </v-btn>
                </template>
            </v-flex>
            <v-flex xs6 class="text-left">
                <template>
                    <v-btn class="ma-2 white--text" @click="$router.push('/daftar-layanan')" color="teal darken-3">
                        <v-icon left>build</v-icon> LAYANAN
                    </v-btn>
                </template>
            </v-flex>
        </v-layout> -->
    </v-container>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { forEach, findIndex, find, remove } from "lodash";
export default {
    name: "Dashboard",
    data: () => ({
        company: {},
        item_products: [],
        item_categories: [],
        isShowProduct: false,
        selectedCategory: null,
        selectedCategoryLayanan: 'ALL',
        menu: false,
        menuFinish: false,
        jamItemsStart: [],
        jamItemsFinish: [],
        startJam: null,
        finishJam: null,
        inputStart: null,
        inputEnd: null,
        name: null,
        details: null,
        start: null,
        end: null,
        color: '#1976D2', // default event color
        currentlyEditing: null,
        selectedEvent: {},
        selectedElement: null,
        selectedJasa: null,
        selectedOpen: false,
        dialog: false,
        available: [],
        jasaItems: [],
        dataJadwal: null,
        alreadyJadwal: false
    }),
    computed: {
        ...mapState({
            listPesanan: state => state.products.listPesanan,
            listProduct: state => state.products.listProduct,
            listLayanan: state => state.jadwal.allProductJasa,
            productJasa: state => state.jadwal.productJasa,
            allProductJasa: state => state.jadwal.allProductJasa,
        }),
    },
    async created(){
        this.showLoading({ color: 'white' })
        await this.getProductJasa('ALL')

        forEach(this.listLayanan, list => {
          list.harga_jual = Number(list.harga_jual)
        })

        for (let i = 0; i < 24; i++) {
          this.jamItemsStart.push({
            text: i.toString().length == 1 ? '0' + i + ':00' : i + ':00',
            value: i.toString().length == 1 ? '0' + i + ':00:01' : i + ':00:01'
          })

          this.jamItemsFinish.push({
            text: i.toString().length == 1 ? '0' + i + ':00' : i + ':00',
            value: i.toString().length == 1 ? '0' + i + ':00:00' : i + ':00:00'
          })
        }

        this.jamItemsFinish.push({
            text: '24:00',
            value: '23:59:00'
        })

        this.company = JSON.parse(window.localStorage.getItem('company'))
        const responseCategory = await this.getProductCategory('ALL')

        if(responseCategory.data.status){
            forEach(responseCategory.data.attributes, data => {
                this.item_categories.push(data)
            })
        }else{
            this.showSnackbar({ text: responseCategory.data.message, color: 'red', timeout: 1500 })
        }

        this.closeLoading()
    },
    methods: {
        ...mapMutations({
            showSnackbar: "showSnackbar",
            showLoading: "showLoading",
            closeLoading: "closeLoading",
            setListPesanan : "products/SET_LIST_PESANAN",
            setListProduct : "products/SET_LIST_PRODUCT",
            setDialogOrder: "pesanan/SET_DIALOG_ORDER",
            setProductJasa : "jadwal/SET_PRODUCT_JASA"
        }),
        ...mapActions({
            getProductJasa: "jadwal/getProductJasa",
            cekJadwal: "jadwal/cekJadwal",
            calculateTotal: "products/calculateTotal",
            dataProducts: "products/getProducts",
            getProductCategory: "products/getProductCategory",
        }),
        async onCekJadwal(){
            let d1 = new Date(this.inputStart + " " + this.startJam.replace(":01", ":00"));
            let d2 = new Date(this.inputEnd + " " + this.finishJam);
            let greaterThanDate = d1.getTime() > d2.getTime();
            
            if(this.inputStart && this.inputEnd && this.startJam && this.finishJam && (this.inputStart + " " + this.startJam.replace(":01", ":00") != this.inputEnd + " " + this.finishJam) && !greaterThanDate){
              forEach(this.listLayanan, list => {
                list.harga_jual = Number(list.harga_jual)
              })

              this.jasaItems = [];
              let available = this.productJasa
              if (this.inputStart && this.inputEnd && this.startJam && this.finishJam && (this.inputStart + " " + this.startJam.replace(":01", ":00") != this.inputEnd + " " + this.finishJam)) {
                const payload = {
                    from: this.inputStart + " " + this.startJam,
                    to: this.inputEnd + " " + this.finishJam
                }
                const response = await this.cekJadwal(payload)

                forEach(response.data.attributes, data => {
                  remove(available, function(currentObject) {
                      return currentObject.value === data.product_id;
                  });
                })

                forEach(available, ava => {
                  this.jasaItems.push(ava)
                })
              } 
            }else{
              this.jasaItems = [];
            }
        },
        async addEvent () {
            const selectedProduct = find(this.allProductJasa, jasa => jasa.id == this.selectedJasa)
            // console.log('selectedProduct', selectedProduct)

            // console.log('this.inputEnd', this.inputEnd)
            // console.log('this.finishJam', this.finishJam)

            let tempFinishJam = this.finishJam == '23:59:00' ? '00:00:00' : this.finishJam

            const start = new Date(this.inputStart+' '+this.startJam)
            let end = new Date(this.inputEnd+' '+tempFinishJam)
            // console.log('end', end)

            if(this.finishJam == '23:59:00'){
                end.setDate(end.getDate() + 1);
            }

            // console.log('end', end)

            let currentPesanan = this.listPesanan
            const itemPesanan = {
                product_id: selectedProduct.id,
                item_name: selectedProduct.name,
                harga_jual: Number(selectedProduct.harga_jual),
                qty: (end - start + 1000)/3600000,
                discount: 0,
                ppn: 0,
                stock: (end - start + 1000)/3600000,
                mulai: this.inputStart+' '+this.startJam,
                selesai: this.inputEnd+' '+this.finishJam
            }

            // console.log('itemPesanan', itemPesanan)

            currentPesanan.push(itemPesanan)

            this.setListPesanan(currentPesanan)
            this.calculateTotal()

            this.dialog = false
            this.inputStart = null
            this.inputEnd = null
            this.startJam = null
            this.finishJam = null
            this.selectedJasa = null
        },
        addToCart(item) {
            let currentPesanan = this.listPesanan
            // console.log(currentPesanan)
            // console.log(item)

            // return console.log(find(currentPesanan, ['item_id', item.id]))

            const findPesanan = findIndex(currentPesanan, ['product_id', item.id])

            if(findPesanan > -1){
                // return console.log(currentPesanan[findPesanan])
                currentPesanan[findPesanan].qty = Number(currentPesanan[findPesanan].qty) + 1
            }else{
                const itemPesanan = {
                    product_id: item.id,
                    item_name: item.name,
                    harga_jual: item.harga_jual,
                    qty: 1,
                    discount: 0,
                    ppn: 0,
                    stock: item.stock,
                    type: item.type
                }
    
                currentPesanan.push(itemPesanan)
            }

            this.setListPesanan(currentPesanan)
            this.calculateTotal()
            // console.log('item', item)
            // console.log('listPesanan', this.listPesanan)
        },
        async onSelectProductCategory(category){
            this.selectedCategory = category
            this.item_products = []
            this.showLoading({ color: 'white' })
            const response = await this.dataProducts(category.id)

            if(response.data.success){
                forEach(response.data.attributes, data => {
                    data.harga_jual = Number(data.harga_jual)
                    data.harga_beli = Number(data.harga_beli)
                    if(data.product_attachment && data.product_attachment.length > 0){
                      data.attachment = process.env.VUE_APP_ENDPOINT_ATTACHMENT_URL + '/' + data.product_attachment[0].location + '/' + data.product_attachment[0].name
                    }
                    this.item_products.push(data)
                })
                this.setListProduct(this.item_products)
                this.isShowProduct = true
            }else{
                this.showSnackbar({ text: response.data.message, color: 'red', timeout: 1500 })
            }
            this.closeLoading()
        },
        openDialogJadwal(){
            this.dialog = true
            this.alreadyJadwal = false
            // forEach(this.listPesanan, listPesan => {
            //     if(listPesan.mulai != undefined){
            //         this.alreadyJadwal = true
            //     }
            // })
        }
    },
};
</script>
<style>
</style>
